import tw, { styled } from "twin.macro";

export const StyledStepOrBackHeader = styled.div`
  ${tw`pt-m pb-m bg-neutral-99 flex justify-between items-center`}
`;
